import { Card, CardContent } from '@/components/ui/card';
import { Layer } from './types';
import { LAYERS_UI_CONFIG } from './constants';

interface HoverPopupProps {
	longitude: number;
	latitude: number;
	properties: Record<string, string>;
	layerType?: Layer;
}

export function HoverPopup({ longitude, latitude, properties, layerType }: HoverPopupProps) {
	const id = properties.id || properties.ID || 'Unknown ID';
	const name = properties.name;

	return (
		<Card className="bg-white/95 dark:bg-slate-900/95 border shadow-sm p-2 min-w-[150px] max-w-[200px] text-xs">
			<CardContent className="p-2 space-y-1">
				<div className="font-medium capitalize">
					{layerType ? LAYERS_UI_CONFIG[layerType].name : 'Unknown Layer'}
				</div>
				<div className="flex gap-2 justify-between">
					<span className="text-slate-600 dark:text-slate-400">ID:</span>
					<span className="font-mono">{id}</span>
				</div>
				{name && (
					<div className="flex gap-2 justify-between">
						<span className="text-slate-600 dark:text-slate-400">Name:</span>
						<span className="truncate max-w-[100px]">{name}</span>
					</div>
				)}
				<div className="text-[0.65rem] mt-2 text-slate-500 dark:text-slate-400 font-mono">
					{latitude.toFixed(4)}, {longitude.toFixed(4)}
				</div>
			</CardContent>
		</Card>
	);
}
